import { Box, styled, Typography } from '@mui/material'

export const Wrapper = styled(Box)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const Text = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.gray9};
  margin-right: 16px;
`

export const IconWrapper = styled(Box)`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
`
